module.exports = __webpack_public_path__ + "img/Logo.4a39162d.svg";